module.exports = __webpack_public_path__ + "img/identity.448347a2.svg";